<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="isOrgAdmin ? $t('org.personnelMgr.inviteDialog.title') : $t('org.personnelMgr.inviteDialog.memberTitle')"
    :class="b()"
    :close-on-click-modal="false"
    append-to-body
    top="10vh"
    data-auto-test-area="zk-org-invite-member"
    @close="onHide"
  >
    <UserUpdateTips
      :need-buy-count="importMemberCount"
      :active-components="activeComponents"
    />
    <el-tabs
      v-model="activeComponents"
      :class="b('content-tabs')"
    >
      <template v-for="item of tabComponents">
        <el-tab-pane
          v-if="item.show"
          :key="item.key"
          :name="item.key"
          :lazy="true"
        >
          <template slot="label">
            <em :class="[item.icon, b('tab-icon')]" />
            <span>{{ item.label }}</span>
          </template>
          <component
            :is="item.component"
            :ref="item.key"
            :active="activeComponents"
            :show-import-member="showImportMember"
            @updateImportMemberCount="updateImportMemberCount"
            @change="$emit('change')"
            @submit="$emit('change')"
            @hide="onHide"
          />
        </el-tab-pane>
      </template>
    </el-tabs>
  </el-dialog>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import UserUpdateTips from 'common-module/src/components/OrganizeInviteMember/UserUpdateTips';
import { isPrivateVersion } from 'common-module/src/util';
import { mapGetters } from 'vuex';


export default {
  name: 'OrganizeInviteMember',
  components: {
    UserUpdateTips
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    showImportMember: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bemNS: theme.bemNS,
      dialogVisible: this.show,
      activeComponents: 'inviteDirectAdd',
      importMemberCount: 0
    };
  },
  computed: {
    ...mapGetters('user', ['roleCodes']),
    isOrgAdmin() {
      const adminCode = ['organizationOwner', 'organizationAdmin'];
      return adminCode.some(code => this.roleCodes.includes(code));
    },
    tabComponents() {
      return [
        {
          key: 'inviteDirectAdd',
          icon: 'zkicon iconrenyuanguanli',
          label: this.$t('org.memberApply.directAdd'),
          component: () => import('common-module/src/components/ImportMemberSteps/InviteDirectAdd'),
          show: this.isOrgAdmin
        },
        {
          key: 'inviteEmail',
          icon: 'zkicon iconyoujianyaoqing',
          label: this.$t('project.inviteMember.dialog.outmember'),
          component: () => import('./InviteEmail'),
          show: !this.isOrgAdmin
        }, {
          key: 'inviteTeamLink',
          icon: 'zkicon iconlianjie',
          label: this.$t('org.memberApply.inviteTeamLink'),
          component: () => import('./InviteTeamLink'),
          show: !isPrivateVersion
        }
      ];
    }
  },
  watch: {
    show(val) {
      this.dialogVisible = val;
    }
  },
  created() {
    this.activeComponents = this.isOrgAdmin ? 'inviteDirectAdd' : 'inviteEmail';
  },
  methods: {
    onHide() {
      this.$emit('close');
    },
    updateImportMemberCount(count) {
      this.importMemberCount = count;
    }
  }
};
</script>

<style lang="scss" scoped>
@include b(organize-invite-member) {
  display: block;
  ::v-deep{
    .el-dialog {
      max-width: 1000px !important;
      width: 1000px;
    }
    .el-dialog__body{
      max-height: calc(100vh - 15vh - 50px - 50px);
      padding-top: 0;
      padding-bottom: 20px;
    }
  }
  @include e(content-tabs){
    @include e(tab-icon) {
      margin-right: 5px;
    }
    ::v-deep {
      .el-tabs__item{
        &.is-active{
          em{
            color: var(--primary-color);
          }
        }
      }
      .el-tabs__header {
        margin: 0 0 12px;
      }
    }
  }
}
</style>
<style lang="scss">
.zk-organize-invite-member {
  .el-tabs__item:focus.is-active.is-focus:not(:active){
    box-shadow: none;
  }
  .el-tabs__item {
    display: inline-flex;
    align-items: center;
  }
}
</style>
